// dynamic-environment.ts
export function getDynamicEnvironment() {
    const tenantName = sessionStorage.getItem('tenant_name') || 'lg';
    
    return {
      production: false,
      // apiUrl: `https://${tenantName}.nubiaemruatbe.ddns.net`,
      apiUrl: `https://${tenantName}.nubiametrics.top`,
    };
  }
  